export default __webpack_public_path__ + "static/media/mainlogo.1eb5ce30.png";